import { styled } from '../../../shared/theming-sc/'
import { textOverflowEllipsis, keyframesFadeIn } from '../../../shared/utilities/styleUtils'

export const StyledContainer = styled.div.attrs({
  style: ({ isParent }) => ({
    paddingRight: isParent ? '50px' : '18px' // Space needed for the caret button
  })
})`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 22px;
  padding-left: 25px;
  border-bottom: 1px solid #d0d3d4;
`

export const StyledBullets = styled.div`
  font-size: 32px;
  letter-spacing: 12px;
  line-height: 0.4;
  color: #AFAFAF;
  user-select: none;
  cursor: default;
`

export const StyledCheckboxWrapper = styled.div`
  margin-top: -1px;
  margin-left: -3px;
`

export const StyledTitle = styled.div`
  margin-left: 7px;
  margin-right: 5px;
  max-width: 100%;
  cursor: default;
  ${textOverflowEllipsis}
`

export const StyledNumSelected = styled.strong.attrs({
  style: ({anim}) => ({animationDuration: anim ? '0.25s' : '0s'})
})`
  animation: ${keyframesFadeIn} 0.2s ease-in-out;
  animation-fill-mode: both;
  transform-origin: 0% 25%;
`
